/* PQ soft geo prompt: suggest the visitor's country/currency, never redirect. */
(function () {
  var KEY = 'pq_geo_dismissed';
  function data() { try { return JSON.parse(document.getElementById('pq-geo-data').textContent); } catch (e) { return null; } }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function detect(d) {
    var test = /[?&]pq_geo_test=([A-Za-z]{2})/.exec(location.search);
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (test && role && role !== 'main') return Promise.resolve(test[1].toUpperCase()); /* test hook: preview themes only */
    return fetch(d.root.replace(/\/$/, '') + '/browsing_context_suggestions.json?country%5Benabled%5D=true&currency%5Benabled%5D=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j.detected_values && j.detected_values.country && j.detected_values.country.handle; })
      .catch(function () { return null; });
  }
  function init() {
    var d = data(), bar = document.getElementById('pq-geo'), form = document.getElementById('PqGeoForm');
    if (!d || !bar || !form) return;
    detect(d).then(function (cc) {
      if (!cc || cc === d.current || !d.countries[cc]) return;
      if (store(KEY) === cc + '>' + d.current) return;
      var c = d.countries[cc];
      bar.querySelector('.pq-geo__msg').textContent = 'Shopping from ' + c[0] + '?';
      bar.querySelector('.pq-geo__switch').textContent = 'Switch to ' + c[1] + ' ' + c[2];
      bar.querySelector('.pq-geo__switch').addEventListener('click', function () {
        form.querySelector('[name=country_code]').value = cc;
        var rt = form.querySelector('[name=return_to]');
        if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
        rt.value = location.pathname + location.search.replace(/([?&])pq_geo_test=[^&]*&?/, '$1').replace(/[?&]$/, '');
        form.submit();
      });
      bar.querySelector('.pq-geo__x').addEventListener('click', function () {
        store(KEY, cc + '>' + d.current); bar.classList.remove('is-on'); setTimeout(function () { bar.hidden = true; }, 260);
      });
      /* keep clear of the mobile sticky Add to Cart bar */
      var sticky = null;
      function place() {
        sticky = sticky || document.querySelector('.pq-sticky-atc');
        var h = sticky && sticky.classList.contains('is-visible') ? sticky.getBoundingClientRect().height : 0;
        bar.style.setProperty('--pq-geo-offset', h + 'px');
      }
      document.addEventListener('pq:sticky-atc', function (e) { bar.style.setProperty('--pq-geo-offset', (e.detail && e.detail.visible ? e.detail.height : 0) + 'px'); });
      place(); var sh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pq-sticky-h')) || 0; if (sh) bar.style.setProperty('--pq-geo-offset', sh + 'px'); bar.hidden = false; requestAnimationFrame(function () { bar.classList.add('is-on'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
